export const GET_ABOUT_DATA = 'about/GET_ABOUT_DATA';
export const GET_ABOUT_ME_DATA = 'about/GET_ABOUT_ME_DATA';